import {Metrics, Network, Post} from "./";
import {Language} from "../types";

export interface LinkData {
  socialLink: string;
  instagramAccount?: string;
}

export interface Addon {
  network: Network;
  metric: MetricType;
  value: number;
}

export enum MetricType {
  Impressions = "impressions",
  Clicks = "clicks",
  ThruPlays = "thruPlays",
  Views = "views",
  StoryViews = "storyViews",
  VideoViews = "videoViews",
  LinkClicks = "linkClicks",
  CrossMedia = "crossMedia",
}

export enum PackageType {
  Basic = "basic",
  Pro = "pro",
  // Legacy Social Links tiers
  Mini= "mini",
  Midi= "midi",
}

export enum ProductId {
  SocialBrandVideo= "social-brand-video",
  SocialLinks = "social-links",
  SocialBrandStories = "social-brand-stories",
  SocialCrossmediaTeaser = "social-crossmedia-teaser",
}

// This is stored in the DB
export interface Product {
  posts: Post[];
  links: LinkData[];
  addons?: Addon[];
  productId: ProductId;
  kpiMetric: MetricType;
  packageType: PackageType;
  language: Language;
}

// Returned to the frontend
export interface Report extends Omit<Product, "links" | "posts"> {
  linksPerPlatform: {
    link: string;
    platform: Network;
  }[];
  // Via report or project
  date: Date;
  // Added by report via social service
  pictureURL: string;
  // Store in DB?
  caption: string;
  // Aggregated metrics over all posts, needs to be fetched
  metrics: Metrics;
  // actually not necessary, since we can get it via kpiMetric
  performance: number;
}